"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export interface ActionCommon {
//     timestamp: string,
// }
//
// export type CommunityActionCommon = {
//     communityId: string
//     communityAccessibility: "open" | "closed",
// } & ActionCommon
//
// export type ChannelActionCommon = {
//     channelId: string
// } & CommunityActionCommon
//
//
// export interface ActionsFirestoreData {
//     actions: Record<string, Action> // string = actionID
// }
//
//
// // ==========================
// // channel actions
// // ==========================
//
// // --------------------------
// // create
// // --------------------------
//
// export const BODY_START_END = 200
// export const BODY_END_MIN_START = 210
// export const BODY_END_MIN_LENGTH = 220
//
// export type ActionType =
//     { actionCategory: "create" } |
//     { actionCategory: "reaction", actionSubCategory: "upVote" }
//
//
// export function getMonthID(dateArg?: Date) {
//     const date = dateArg || new Date()
//     return date.getFullYear().toString() + "_" + date.getMonth().toString()
// }
//
// export function createBodyTeaser(body: string) {
//     return {
//         bodyStart: body.slice(0, BODY_START_END),
//         bodyEnd: body.length > BODY_END_MIN_LENGTH ?
//             body.slice(Math.max(BODY_END_MIN_START, body.length - BODY_END_MIN_START)) : null
//     }
// }
//
// export function createActionId(actionType: ActionType, refId: string) {
//     // NOTE, potentially, someone with bad intentions could create documents with same IDs but in different
//     collections
//     // This could potentially lead to a state where two action IDs are identical.
//     // However, only the user itself is affected by their own bad intentions.
//     if("actionSubCategory" in actionType) {
//         return `${actionType.actionCategory}_${actionType.actionSubCategory}_${refId}`
//     } else {
//         return `${actionType.actionCategory}_${refId}`
//     }
// }
//
// export type CreateAction = CreateIssueAction | CreateAnswerAction | CreateProposalAction | CreateCommentAction |
//     CreateSubCommentAction
// export type ReactionAction = UpVoteIssueAction | UpVoteAnswerAction | UpVoteProposalAction | UpVoteCommentAction
//
// export type Action = CreateAction | ReactionAction
//
// export type refTypes = "issue" | "answer" | "proposal" | "comment" | "subComment"
//
// export type CreateIssueAction = {
//     actionCategory: "create"
//     refType: "issue",
//     refId: string,
// } & ChannelActionCommon
//
// export type CreateAnswerAction = {
//     actionCategory: "create"
//     refType: "answer",
//     refId: string,
// } & ChannelActionCommon
//
// export type CreateProposalAction = {
//     actionCategory: "create",
//     refType: "proposal",
//     refId: string,
// } & ChannelActionCommon
//
// export type CreateCommentAction = {
//     actionCategory: "create",
//     refType: "comment",
//     refId: string,
// } & ChannelActionCommon
//
// export type CreateSubCommentAction = {
//     actionCategory: "create"
//     refType: "subComment",
//     refId: string,
// } & ChannelActionCommon
//
// // --------------------------
// // reactions
// // --------------------------
//
// export type UpVoteIssueAction = {
//     actionCategory: "reaction",
//     actionSubCategory: "upVote",
//     refType: "issue",
//     refId: string,
// } & ActionCommon
//
// export type UpVoteAnswerAction = {
//     actionCategory: "reaction"
//     actionSubCategory: "upVote"
//     refType: "answer",
//     refId: string,
// } & ActionCommon
//
// export type UpVoteProposalAction = {
//     actionCategory: "reaction"
//     actionSubCategory: "upVote"
//     refType: "proposal",
//     refId: string,
// } & ActionCommon
//
// export type UpVoteCommentAction = {
//     actionCategory: "reaction",
//     actionSubCategory: "upVote",
//     refType: "comment",
//     refId: string,
// } & ActionCommon
//
//
// // ==========================
// // community actions
// // ==========================
//
// export type CreateChannelAction = {
//     actionCategory: "create",
//     refType: "channel",
//     refId: string,
// } & CommunityActionCommon
//
// export type CreateCommunityAction = {
//     actionCategory: "create"
//     refType: "community"
//     refId: string,
// } & ActionCommon
